// extracted by css-extract-rspack-plugin
module.exports =  {"answer":"Template33-Ua_T__answer","answer__correct":"Template33-yLG8__answer__correct"};